<div
  *ngIf="open"
  class="fixed top-0 left-0 flex justify-center items-center w-full h-full z-50 overflow-hidden bg-black/90 z-[100]"
  tabindex="0"
  (keydown)="onClose()"
  (click)="onClose()"
  (wheel)="$event.preventDefault()"
  (touchmove)="$event.preventDefault()"
>

<!-- Previous Button -->
  <div
    *ngIf="prevImage !== index"
    class="absolute left-2 z-20 size-[2.5rem] cursor-pointer rounded-lg bg-white/60 hover:bg-white transition-colors duration-300 flex items-center justify-center"
    (click)="$event.stopPropagation(); prev()"
    (keydown.enter)="$event.stopPropagation(); prev()"
    tabindex="0"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        stroke-dasharray="12"
        stroke-dashoffset="12"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 12l7 -7M8 12l7 7"
      >
        <animate
          fill="freeze"
          attributeName="stroke-dashoffset"
          dur="0.3s"
          values="12;0"
        />
      </path>
    </svg>
  </div>

  <div
    [class.gallery__content--no-thumbs]="noThumbs"
    (touchstart)="swipeStart($event)"
    (touchmove)="swipe($event)"
  >
    <!-- Loader placeholder -->
    <!-- <div class="gallery__loader text-red-600">
      <p>Loading...</p>
    </div> -->

    <ng-container *ngIf="images && images[index]">
      <div
        [@slideAnimation]="slide"
        tabindex="0"
        (keydown)="$event.stopPropagation(); next()"
        class="gallery__content__image"
        (click)="$event.stopPropagation(); next()"
      >
        <ng-container *ngIf="isVimeo(); else imageBlock">
          <iframe
            [src]="getVideoUrl()"
            style="
              position: fixed;
              top: 0;
              z-index: 50;
              left: 0;
              width: 100%;
              height: 100%;
            "
            width="100%"
            height="100%"
            allowfullscreen
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
          ></iframe>
        </ng-container>

        <ng-template #imageBlock>
          <div class="bg-gray-500">
            <img
              [src]="getImageSrc()"
              [alt]="getImageAlt()"
              (click)="$event.stopPropagation()"
              tabindex="0"
              (keydown.enter)="$event.stopPropagation()"
            />
          </div>
        </ng-template>
      </div>
    </ng-container>

    <!-- Close Button -->
    <div
      class="bg-white/60 absolute top-2 right-2 z-20 bg-white/60 size-[2.5rem] cursor-pointer rounded-lg hover:bg-white/90 flex items-center justify-center"
      (click)="$event.stopPropagation(); onClose()"
      tabindex="0"
      (keydown.enter)="$event.stopPropagation(); onClose()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
        />
      </svg>
    </div>

    <!-- Close Button -->
    <div
      class="bg-white/60 absolute top-2 right-2 z-20 bg-white/60 size-[2.5rem] cursor-pointer rounded-lg hover:bg-white/90 flex items-center justify-center"
      tabindex="0"
      (keydown.enter)="$event.stopPropagation(); onClose()"
      (click)="$event.stopPropagation(); onClose()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
        />
      </svg>
    </div>
  </div>

   <!-- Next Button -->
    <div
      *ngIf="nextImage !== index"
      class="absolute right-2 z-20 size-[2.5rem] cursor-pointer rounded-lg bg-white/60 hover:bg-white transition-colors duration-300 flex items-center justify-center"
      (click)="$event.stopPropagation(); next()"
      (keydown.enter)="$event.stopPropagation(); next()"
      tabindex="0"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-dasharray="12"
          stroke-dashoffset="12"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 12l-7 -7M16 12l-7 7"
        >
          <animate
            fill="freeze"
            attributeName="stroke-dashoffset"
            dur="0.3s"
            values="12;0"
          />
        </path>
      </svg>
    </div>

  <div
    *ngIf="!noThumbs"
    class="gallery__thumbs"
    (touchmove)="$event.stopPropagation()"
    (wheel)="$event.stopPropagation()"
  >
    <img
      *ngFor="let image of images; let idx = index"
      [class.gallery__thumbs__item--active]="index === idx"
      [src]="getThumbnail(image)"
      [alt]="getImageAlt()"
      class="gallery__thumbs__item"
      (click)="$event.stopPropagation(); goto(idx)"
      tabindex="0"
      (keydown.enter)="$event.stopPropagation(); goto(idx)"
    />
  </div>
</div>

<script src="https://player.vimeo.com/api/player.js"></script>
